"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ODataExpressionVisitor = exports.ODATA_OPERATOR_DISPLAY_NAME = void 0;
exports.ODATA_OPERATOR_DISPLAY_NAME = {
    or: 'or',
    and: 'and',
    eq: 'is equal to',
    ne: 'is not equal to',
    gt: 'is greater than',
    ge: 'is greater than or equal to',
    lt: 'is less than',
    le: 'is less than or equal to',
    add: 'add',
    sub: 'subtract',
    div: 'divide',
    mul: 'muiltiplied by',
    mod: 'modulo remainder',
};
/**
 * @class Visitor - Abstract base class which all visitors must inherit from.
 */
class ODataExpressionVisitor {
    static accept(node, visitor, level) {
        if (!level) {
            level = 0;
        }
        if (visitor instanceof ODataExpressionVisitor) {
            return visitor.visit(node, ++level);
        }
    }
    /**
     * Determines whether the specified is a binary operator node. That is, the
     * node has a type that is a logical comparator (or/and).
     *
     * @param {ASTNode} An AST node instance
     *
     * @return {Boolean} True if the provided node is a binary operator node.
     */
    isBinaryOperator(node) {
        return node.type === 'or' || node.type === 'and';
    }
    /**
     * Returns a number identifying the operator precedence for a binary
     * expression node according to the OData specification.
     *
     * @param {ASTNode} node An AST node instance to return the precedence on its
     * operator for
     *
     * @return {Number} A number representing the operator precedence for the
     * given node's operator
     */
    binaryOperatorPresedence(node) {
        switch (node.type) {
            case 'or':
                return 1;
            case 'and':
                return 2;
            case 'eq':
            case 'ne':
            case 'gt':
            case 'ge':
            case 'lt':
            case 'le':
                return 3;
            case 'add':
            case 'sub':
                return 4;
            case 'div':
            case 'mul':
            case 'mod':
                return 5;
            default:
                return -1;
        }
    }
    /**
     * Forces a node acceptor to visit a node.
     *
     * @return {Object} (optional) Returns the result of the node visit as
     * implemented by the visitor.
     */
    visit(node, ...args) {
        let value;
        switch (node.type) {
            case 'property':
                value = this.visitPropertyNode(node, ...args);
                break;
            case 'literal':
                value = this.visitLiteralNode(node, ...args);
                break;
            case 'functioncall':
                value = this.visitFunctionCallNode(node, ...args);
                break;
            case 'and':
            case 'or':
                value = this.visitBinaryExpressionNode(node, ...args);
                break;
            default:
                value = this.visitConditionalNode(node, ...args);
        }
        return value;
    }
}
exports.ODataExpressionVisitor = ODataExpressionVisitor;
//# sourceMappingURL=odata-expression-visitor.js.map